export const ROLE_VIEW = 'ROLE_VIEW';
export const ROLE_VIEW_LOADED = 'ROLE_VIEW_LOADED';
export const ROLE_LIST_ALL = 'ROLE_LIST_ALL';
export const ROLE_LISTED_ALL = 'ROLE_LISTED_ALL';
export const ROLE_UNLOAD = 'ROLE_UNLOAD';
